export default __webpack_public_path__ + "static/media/download-certificate.9a12bb88.svg";